import React from 'react'
import { connect } from 'react-redux'

import { 
  addCouponAsync,
  removeCouponAsync,
  updateCouponAsync
} from './couponActions'

import {
  CheckoutSection,
} from '../../components'

import {
  hiddenAnchorStyle
} from '../../components/styles'

import isEqual from 'lodash/isEqual';
import isEqualWith from 'lodash/isEqualWith';
import sortBy from 'lodash/sortBy';
import { TranslationUtility } from "../../../util/translationUtility";

const cartItemPropertiesToCompare = ['Id', 'Price', 'SKU', 'Quantity'];

function cartItemComparer(first, second) {
  cartItemPropertiesToCompare.every((propName) => first && second && (first[propName] === second[propName]));
}

const placeOrderDetailsChanged = (prevProps, newProps) =>
    !isEqualWith(sortBy(prevProps.cart, ['Id']), sortBy(newProps.cart, ['Id']), cartItemComparer) ||
    !isEqual(prevProps.shippingAddress, newProps.shippingAddress) ||
    prevProps.shippingOptionId !== newProps.shippingOptionId;

class CheckoutCoupon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedCouponCode: props.couponCode
    };
    this.onClickChange = this.onClickChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.translationUtility = new TranslationUtility(props.localizationItems)
  }

  onClickChange(e) {
    e.preventDefault();
    this.props.onClear();
  }

  onSubmit(e) {
    e.preventDefault();
    const {
      editedCouponCode
    } = this.state;
    this.props.onSave(editedCouponCode);
  }

  componentDidUpdate(prevProps) {
    if (placeOrderDetailsChanged(prevProps, this.props)) {
      this.props.updateCoupon(this.state.editedCouponCode);
    }
  }

  render() {
    const {
      editedCouponCode
    } = this.state;
    const {
      onSave,
      couponCode,
      setCouponCode
    } = this.props;
    return (
    <CheckoutSection label={this.translationUtility.translateResourceString("/Checkout/Coupon/Label")} hidden={false}>
      {setCouponCode &&
        <div style={{ lineHeight: 2 }}>
          <a
            href=""
            style={hiddenAnchorStyle}
            onClick={this.onClickChange}
          >
            {couponCode}
            <span style={{ marginLeft: 20, color: '#003057' }}>
              Change
            </span>
          </a>
      </div>}
      {!setCouponCode &&
        <div>
          <form onSubmit={this.onSubmit}>
            <input
              name="checkout-coupon"
              type="text"
              className="form-control"
              value={editedCouponCode}
              style={{display: 'inline', width: '200px'}}
              onChange={(e) => this.setState({editedCouponCode: e.target.value})}
            />
            <span 
              onClick={() => onSave(editedCouponCode)}
              style={{marginLeft: '20px'}}
            >
              Apply
            </span>
          </form>
        </div>
      }
    </CheckoutSection>
    )
  }
}

const mapCouponStateToProps = (state) => {
  const selectedShippingAddressId = state.entities.SelectedShippingAddressId
  return {
    setCouponCode: state.entities.CouponCode ? true : false,
    couponCode: state.entities.CouponCode,
    cart: state.entities.CartItems,
    shippingAddress: state.entities.Addresses.find(addr => addr.Id === selectedShippingAddressId),
    shippingOptionId: state.entities.SelectedShippingOptionId,
    localizationItems: state.constants.localizationItems
  }
}

const mapCouponDispatchToProps = (dispatch) => {
  return {
    onSave: (couponCode) => dispatch(addCouponAsync({CouponCode: couponCode})),
    onClear: () => dispatch(removeCouponAsync()),
    updateCoupon: () => dispatch(updateCouponAsync())
  }
}

const CheckoutCouponContainer = connect(mapCouponStateToProps, mapCouponDispatchToProps)(CheckoutCoupon);

export default CheckoutCouponContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Coupon/CheckoutCoupon.jsx